import * as React from "react";
const CircleAndSquare = ({ title, titleId, desc, descId }) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 96 96", "aria-labelledby": titleId, "aria-describedby": descId },
    desc ? React.createElement("desc", { id: descId }, desc) : null,
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("mask", { id: "prefix__a", width: 96, height: 96, x: 0, y: 0, maskUnits: "userSpaceOnUse", style: {
            maskType: "luminance",
        } },
        React.createElement("path", { fill: "#fff", d: "M95.5.5H.5v95h95z" })),
    React.createElement("g", { mask: "url(#prefix__a)" },
        React.createElement("path", { fill: "#CFCFCF", d: "M95.5 32.2H.6v63.3h94.9z" }),
        React.createElement("path", { fill: "#ED0000", d: "M48 1.2c-17.1 0-31 13.9-31 31h62c0-17.2-13.9-31-31-31" }),
        React.createElement("path", { fill: "#3F3F3F", d: "M48 63.2c17.1 0 31-13.9 31-31H17c0 17.1 13.9 31 31 31" }))));
export default CircleAndSquare;
//# sourceMappingURL=CircleAndSquare.js.map